<template>
    <div class="card-container">
        <loader
            v-if="loading"
        />
        <workload-graph
            v-else
            ref="chart"
            :chart-data="workload"
            :legend="legend"
            style="height: 150px;"
            @click="route_to_record"
        />
        <!--
        <div class="uk-text-center">
            <button type="button" @click.prevent="legend=!legend" class="uk-button uk-button-link uk-button-mini">
                <span v-if="!legend">Show</span><span v-else>Hide</span> Legend
            </button>
        </div>
        //-->
    </div>
</template>

<script type="text/javascript">
import { mapState } from "vuex"
import { draw } from "patternomaly"
import { sum, orderBy } from "lodash"

import profile_utilities from "../../mixins/ProfileUtilities"
import ui_utilities from "../../mixins/UiUtilities"
import dashboard_card from "./dashboard_card"

import WorkloadGraph from "./WorkloadGraph.js"
import Loader from "../../ui/Loader"

export default {
    mixins: [profile_utilities, ui_utilities, dashboard_card],
    components: {
        WorkloadGraph,
        Loader
    },
    mounted () {
        this.load_data()
    },
    watch: {
        profile_id: "load_data",
        $route: "load_data"
    },
    methods: {
        load_data () {
            if(this.profile_id) {
                this.loading = true
                this.$store.dispatch("DASHBOARD_DATA", { entity: this.card.entity, data_id: this.card.id }).then(() => {
                    // all good!
                }).catch(error => {
                    console.error(error)
                }).then(() => {
                    this.loading = false
                })
            }
        }
    },
    computed: {
        ...mapState(["dashboard_workload"]),
        workload () {
            const data = { labels: [], datasets: [] }
            const time_off_dataset = {
                label: "OFF",
                backgroundColor: draw("diagonal", "#ddd"),
                data: []
            }

            const date = this.$moment().startOf("week")
            for(let loop = 0; loop < 4; loop++) {
                let label = "This Week"
                if(loop === 1) label = "Next Week"
                else if(loop === 2) label = "3rd Week"
                else if(loop === 3) label = "4th Week"
                data.labels.push(label)

                const days_off = this.off_days(this.record, date, this.$moment(date).add(6, "days"))
                time_off_dataset.data[loop] = (days_off * this.$root.applicationSettings.work_day_hours) || null

                date.add(1, "week")
            }
            if(this.dashboard_workload) {
                orderBy(this.dashboard_workload, project => {
                    return sum(project.hours)
                }, "desc").forEach(project => {
                    if(sum(project.hours) > 0) {
                        data.datasets.push({
                            label: project.label,
                            backgroundColor: project.color,
                            borderColor: "#ffffff",
                            borderWidth: 1,
                            categoryPercentage: 0.9,
                            barPercentage: 0.8,
                            data: project.hours,
                            project: project
                        })
                    }
                })
            }

            data.datasets.push(time_off_dataset)

            return data
        }
    },
    data () {
        return {
            legend: false
        }
    }
}
</script>
